import Vue from "vue";
import Vuetify from "vuetify/lib";
import colors from "vuetify/lib/util/colors";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#00BCD4",
        secondary: "#00363A",
        primary_general: "#3e5d58",
        secondary_general: "#b5bd00",
        grey: colors.grey.base
      }
    }
  }
});
